// import { width } from '@mui/system';
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, NavLink, useHistory } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "../Components/Component-css/Header.css";
import css from "./Component-css/Nav.module.css";
import { BsPeople } from 'react-icons/bs';
import BottonMenu from "../uiComponents/BottonMenu";
import { BsWallet, BsGift } from 'react-icons/bs'
import { IoMdNotificationsOutline } from "react-icons/io";
import { FiPlus } from "react-icons/fi";
import "../Components/Component-css/Header.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { LanguageContext } from "./LanguageContext";
import { useContext } from "react";
import { useTheme } from "../../ThemeContext";
import { apiRequest } from "../../apiService/allApi";
import { FaPlus } from "react-icons/fa";
import { FaUsers } from "react-icons/fa6";
import { useLocation } from "react-router-dom";
import { IoMenu } from "react-icons/io5";

const w3_close = () => {
  const sidebar = document.getElementById("gold_sidebar");
  const overlay = document.getElementById("sidebarOverlay");

  if (sidebar) {
    sidebar.style.left = "-320px";
  }

  if (overlay) {
    overlay.style.display = "none";
  }
};

const w3_open = () => {
  const sidebar = document.getElementById("gold_sidebar");
  const overlay = document.getElementById("sidebarOverlay");

  if (sidebar) {
    sidebar.style.left = "0";
  }

  if (overlay) {
    overlay.style.display = "block";
  }
};

const addsetting = localStorage.getItem("sitSetting");

const addCaseSetting = JSON.parse(addsetting);
const udata = localStorage.getItem("udata");
const profileData = JSON.parse(udata);

const Header = ({ user }) => {
  const location = useLocation();

  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++
  const [isdropdownVisible, setIsdropdownVisible] = useState(false);

  const toggleDiv = () => {
    setIsdropdownVisible(!isdropdownVisible);
  };

  const history = useHistory();

  let access_token = localStorage.getItem("token");
  access_token = localStorage.getItem("token");

  const logout = async () => {
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const respone = await apiRequest(`logout`, "POST", null, headers)

    localStorage.removeItem("token");
    window.location.reload();
    history.push("/");

  };

  const [promptInstall, setPromptInstall] = useState(null);
  const [supportsPWA, setSupportsPWA] = useState(false)


  useEffect(() => {
    const handler = e => {
      e.preventDefault();
      console.log('beforeinstallprompt event was fired');
      setPromptInstall(e);
      setSupportsPWA(true)
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) {
      console.log('No promptInstall event available');
      return;
    }
    promptInstall.prompt();
    promptInstall.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the install prompt');
      } else {
        console.log('User dismissed the install prompt');
      }
      setPromptInstall(null);
    });
  };

  // language
  const { changeLanguage } = useContext(LanguageContext);
  const translations = {
    hi: {
      commission: "कमीशन: 5% : रेफरल: सभी खेलों के लिए 3%",
      profile: "मेरी प्रोफाइल",
      play: "खेले",
      wallet: "वॉलेट",
      refer: "रेफरल और कमाएँ",
      history: "इतिहास",
      support: "सहायता",
      // app: "ऐप डाउनलोड",
      kyc: "केवाईसी"
    },
    en: {
      commission: "COMMISSION: 5% : REFERRAL: 3% FOR ALL GAMES",
      profile: "My Profile",
      play: "Play",
      wallet: "My Wallet",
      refer: "Refer and Earn",
      history: "History",
      support: "Support",
      notify: "Notification",
      // app: " App ",
      kyc: "KYC",
    },
  };

  const { language } = useContext(LanguageContext);

  // // change theme 
  // const { theme, toggleTheme } = useTheme("light");
  // const theme1 = localStorage.getItem('theme')

  // const styles = {
  //   backgroundColor: theme1 === 'light' ? '#000' : 'black',
  //   color: theme1 === 'light' ? '#fff' : '#fff',
  // };
  // const styles1 = {
  //   backgroundColor: theme1 === 'light' ? '#fff' : '#6c757d',
  //   color: theme1 === 'light' ? 'black !important' : '#fff !important',

  // };
  // const logo = theme1 === 'light' ? '../images/malik-ludo-logo1.png' : '../images/malik-ludo-logo1.png';

  // const colorChange = () => {
  //   localStorage.setItem("theme", "#fff")
  //   toggleTheme('#fff')
  // }

  // useEffect(() => {
  //   localStorage.setItem("theme", "light")

  // }, [])

  const { theme, toggleTheme } = useTheme();




  return (
    <>
      <div>
        {access_token ? (
          <React.Fragment>
            {/* <div id="sidebarOverlay" onClick={w3_close}></div> */}
            <div id="sidebarOverlay" className="gold_sidebar_overlay" onClick={w3_close}></div>

            <div className="gold_sidebar_wrapper">

              <div
                className="gold_sidebar"
                id="gold_sidebar"
              >

                <span className="gold_close_btn" onClick={w3_close}>
                  <img src="../close.png" alt="" />
                </span>

                {/* HEADER */}

                <div className="gold_sidebar_header">

                  <div className="gold_logo_box">
                    {/* <img src="../images/malik-ludo-logo1.png" className="img-fluid" /> */}
                    <img
                      src="../images/malik-ludo-logo1.png"
                      className="header_logo"
                      alt="logo"
                    />

                  </div>

                </div>

                {/* PROFILE */}

                <Link
                  to={"/Profile"}
                  className="gold_menu_card"
                  onClick={w3_close}
                >
                  <picture className="gold_menu_icon">

                    {user && user?.avatar ? (
                      <img
                        width="30"
                        height="30"
                        src={baseUrl + user?.avatar}
                        alt="profile"
                        style={{ borderRadius: "50%" }}
                      />
                    ) : (
                      <img
                        src="images/icons/sidebar-user.png"
                        alt="profile"
                      />
                    )}

                  </picture>

                  <h3>{translations[language].profile}</h3>

                  <img
                    className="gold_menu_arrow"
                    src="https://cdn-icons-png.flaticon.com/128/724/724816.png"
                    alt=""
                  />
                </Link>

                {/* PLAY */}

                <Link
                  to={"/Homepage/ludoClassicManual"}
                  className="gold_menu_card"
                  onClick={w3_close}
                >
                  <picture className="gold_menu_icon">
                    <img
                      alt=""
                      src="/images/icons/play-button.png"
                    />
                  </picture>

                  <h3>{translations[language].play}</h3>

                  <img
                    className="gold_menu_arrow"
                    src="https://cdn-icons-png.flaticon.com/128/724/724816.png"
                    alt=""
                  />
                </Link>

                {/* WALLET */}

                <Link
                  to={"/wallet"}
                  className="gold_menu_card"
                  onClick={w3_close}
                >
                  <picture className="gold_menu_icon">
                    <img
                      alt=""
                      src="/images/icons/digital-wallet.png"
                    />
                  </picture>

                  <h3>{translations[language].wallet}</h3>

                  <img
                    className="gold_menu_arrow"
                    src="https://cdn-icons-png.flaticon.com/128/724/724816.png"
                    alt=""
                  />
                </Link>

                {/* REFERRAL */}

                {addCaseSetting?.isReferral && (
                  <Link
                    to={"/refer"}
                    className="gold_menu_card"
                    onClick={w3_close}
                  >
                    <picture className="gold_menu_icon">
                      <img
                        alt=""
                        src="/images/icons/refer1.png"
                      />
                    </picture>

                    <h3>{translations[language].refer}</h3>

                    <img
                      className="gold_menu_arrow"
                      src="https://cdn-icons-png.flaticon.com/128/724/724816.png"
                      alt=""
                    />
                  </Link>
                )}

                {/* HISTORY */}

                <Link
                  to={"/history"}
                  className="gold_menu_card"
                  onClick={w3_close}
                >
                  <picture className="gold_menu_icon">
                    <img
                      alt=""
                      src="/images/icons/refresh.png"
                    />
                  </picture>

                  <h3>{translations[language].history}</h3>

                  <img
                    className="gold_menu_arrow"
                    src="https://cdn-icons-png.flaticon.com/128/724/724816.png"
                    alt=""
                  />
                </Link>

                <Link
                  to="/Profile?kyc=true"
                  className="gold_menu_card"
                  onClick={w3_close}
                >
                  <picture className="gold_menu_icon">
                    <img
                      alt=""
                      src="/images/kyc.png"
                    />
                  </picture>

                  <h3>KYC Verification</h3>

                  <img
                    className="gold_menu_arrow"
                    src="https://cdn-icons-png.flaticon.com/128/724/724816.png"
                    alt=""
                  />
                </Link>

                {/* SUPPORT */}

                <Link
                  to={"/support"}
                  className="gold_menu_card"
                  onClick={w3_close}
                >
                  <picture className="gold_menu_icon">
                    <img
                      alt=""
                      src="/images/support.jpg"
                    />
                  </picture>

                  <h3>{translations[language].support}</h3>

                  <img
                    className="gold_menu_arrow"
                    src="https://cdn-icons-png.flaticon.com/128/724/724816.png"
                    alt=""
                  />
                </Link>

                {/* NOTIFICATION */}

                {/* <Link
                  to={"/Notification"}
                  className="gold_menu_card"
                  onClick={w3_close}
                >
                  <picture className="gold_menu_icon">
                    <img
                      alt=""
                      src="/images/icons/notification.png"
                    />
                  </picture>

                  <h3>{translations[language].notify}</h3>

                  <img
                    className="gold_menu_arrow"
                    src="https://cdn-icons-png.flaticon.com/128/724/724816.png"
                    alt=""
                  />
                </Link> */}
                {/* <button
                  className="theme_toggle_btn"
                  onClick={toggleTheme}
                >
                  {theme === "light" ? "🌙" : "☀️"}
                </button> */}
                <div
                  className="gold_menu_card"
                  onClick={toggleTheme}
                  style={{ cursor: "pointer" }}
                >
                  <picture className="gold_menu_icon">
                    <img
                      src={
                        theme === "light"
                          ? "https://cdn-icons-png.flaticon.com/128/10976/10976127.png"
                          : "https://cdn-icons-png.flaticon.com/128/8484/8484254.png"
                      }
                      alt="theme"
                    />
                  </picture>

                  <h3>
                    {theme === "light" ? "Dark Mode" : "Light Mode"}
                  </h3>

                  <img
                    className="gold_menu_arrow"
                    src="https://cdn-icons-png.flaticon.com/128/11160/11160807.png"
                    alt=""
                  />
                </div>

                {supportsPWA && (
                  <div
                    className="gold_install_card"
                    onClick={onClick}
                  >
                    <div className="gold_install_icon">
                      📲
                    </div>

                    <div className="gold_install_content">
                      <h4>Install App</h4>
                      <p>Fast access & better experience</p>
                    </div>


                  </div>
                )}


              </div>

            </div>


            <header className="premium_header">
              <div className="premium_header_inner">
                <button
                  className="menu_btn"
                  onClick={w3_open}
                  id="hambergar"
                >
                  <IoMenu className="menu_icon" />
                </button>

                <Link to="/">
                  {/* <img
                    src={logo}
                    className="header_logo"
                    alt="logo"
                  /> */}
                  <img
                    src="../images/malik-ludo-logo1.png"
                    className="header_logo"
                    alt="logo"
                  />
                </Link>
              </div>

              <div className="header_right">

                <NavLink
                  exact
                  to="/Addcase"
                  className="header_stat_box blue_stat_box"
                >
                  <div className="stat_icon_wrap">
                    <img src="https://cdn-icons-png.flaticon.com/128/12254/12254603.png" alt="" />
                  </div>

                  <div className="stat_content">
                    <h4>{user?.Wallet_balance || 0}</h4>
                    <span>Coins</span>
                  </div>
                </NavLink>

                <NavLink
                  exact
                  to="/redeem/refer"
                  className="header_stat_box pink_stat_box"
                >
                  <div className="stat_icon_wrap">
                    <img src="https://cdn-icons-png.flaticon.com/128/10536/10536043.png" alt="" />
                  </div>

                  <div className="stat_content">
                    <h4>
                      {user?.referral_wallet?.toFixed(2) || "0.00"}
                    </h4>
                    <span>Referral </span>
                  </div>
                </NavLink>

              </div>
            </header>
          </React.Fragment>
        ) : (
          <>
            {/* <div className="w3-teal " style={styles}>
            <div className="w3-container ">
              <div className={`${css.headerContainer} justify-content-between`}>
                <Link to="/">
                  <picture className={`ml-2 ${css.navLogo} d-flex`}>
                    <img
                      src="./images/malik-logo.png"
                      className="snip-img"
                      alt="Malik "
                      width="30px"
                    />
                  </picture>
                </Link>

                <div className={`ml-5`}>
                  <Link type="button" className="login-btn" to="/login">
                    LOGIN
                  </Link>
                </div>
              </div>
            </div>
          </div> */}
          </>
        )}
      </div>
      {location.pathname !== "/login" && (
        <div className="bottom_menus_main">
          <BottonMenu w3_close={w3_close} />
        </div>
      )}
    </>
  );
};

export default Header;
